
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ProtectedRoute = ({ children }) => {
    const { user, loading } = useAuth();
    const navigate = useNavigate();
    if (!user) {
        navigate('/login');
        return null;
    }
    if (loading) {
        return (<div className="loading-spinner"> Loading... </div>);
    }

   



    return children;
};

export default ProtectedRoute;